import { ArrowRight } from "lucide-react";
import { useSettings } from "../../hooks/useSettings";
import { track } from "../../lib/analytics";
import { ctaState } from "../../lib/cta";
import { StoreBadges } from "./StoreBadges";
import { useGetApp } from "./GetAppModal";

/**
 * The single primary conversion control, driven by admin settings.
 * When downloads are live it points at the stores; until then it drives the
 * early-access list. Repeated verbatim above and below the fold.
 */
export function DownloadCTA({
  source = "hero",
  className = "",
  showBadges = true,
  tone = "default",
}: {
  source?: string;
  className?: string;
  showBadges?: boolean;
  /** "onColor" flips the button to white-on-teal for use over a colored band. */
  tone?: "default" | "onColor";
}) {
  const s = useSettings();
  const { live, target } = ctaState(s);
  const { open } = useGetApp();

  const onPrimary = () => {
    track("cta_primary_click", { source, live });
    if (live && s.app_store_url) {
      window.location.href = s.app_store_url;
    } else {
      // No live store link yet — capture the lead and text them the app.
      open({ source });
    }
  };

  const primaryCls =
    tone === "onColor"
      ? "btn group border-[3px] border-navy bg-sun px-7 py-3.5 text-base text-navy shadow-pop-white hover:translate-x-[3px] hover:translate-y-[3px] hover:bg-sun-light hover:shadow-none"
      : "btn-primary group px-7 py-3.5 text-base";

  return (
    <div className={`flex flex-col items-start gap-4 ${className}`}>
      <button onClick={onPrimary} className={primaryCls}>
        {live ? "Get FitBuddy free" : "Join the early list"}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </button>
      {showBadges && (
        <StoreBadges
          appStoreUrl={s.app_store_url}
          googlePlayUrl={s.google_play_url}
          live={live}
          source={source}
          fallbackId={target}
        />
      )}
    </div>
  );
}
